import { showAction } from '../../../actions/cross_sell_remove_light_box_actions';

const onRemoveCrossSellClick = (e, obj) => {
  e.preventDefault();
  showAction(obj);
};

export default onRemoveCrossSellClick;
